export const currentLang = () => document.documentElement.lang || 'lv';
